import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-popup-driver-schedule',
  templateUrl: './popup-driver-schedule.component.html',
  styleUrls: ['./popup-driver-schedule.component.scss']
})
export class PopupDriverScheduleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/popup-driver-schedule/popup-driver-schedule.component.ts